import { render, staticRenderFns } from "./MenuItemVOD.vue?vue&type=template&id=fbd6f04e&scoped=true&"
import script from "./MenuItemVOD.vue?vue&type=script&lang=js&"
export * from "./MenuItemVOD.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemVOD.vue?vue&type=style&index=0&id=fbd6f04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6f04e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fbd6f04e', component.options)
    } else {
      api.reload('fbd6f04e', component.options)
    }
    module.hot.accept("./MenuItemVOD.vue?vue&type=template&id=fbd6f04e&scoped=true&", function () {
      api.rerender('fbd6f04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemVOD.vue"
export default component.exports